/**
 * The page, in the order somebody reads it.
 *
 * WHY ONE PAGE. A reader deciding whether to try a product they have never
 * heard of gives it one scroll; the header's links are anchors into it, so
 * there is no router and no second HTML file.
 *
 * THE ORDER IS THE ARGUMENT — shown, not told (the owner's brief for this
 * rebuild: "i am selling reach, connect, sense and flow … showing things in
 * action … makes him/her to try it one time"):
 *
 *   1. the hero: the four parts as one loop, the mark drawing itself;
 *   2. Reach, Connect, Sense, Flow — one section each, a few words and an
 *      animated picture of the part working (sections/Pillars.tsx);
 *   3. "See it work": the interactive loop, then three hands-on tabs over
 *      example data — build a segment, run a flow, follow one person
 *      (sections/Loop.tsx);
 *   4. four promises, one line each (sections/Proof.tsx);
 *   5. the ask: "Try Wend once" (sections/Interest.tsx).
 *
 * NO NETWORK BEYOND THE ENQUIRY. The demos run on example data bundled into
 * the page; the only call it makes is the form's POST /public/interests
 * (scripts/verify-site-copy checks every source file for another).
 *
 * The skip link is first in the DOM because the header is sticky.
 */
import { SiteFooter, SiteHeader } from './components/site-chrome';
import { CONTACT_EMAIL } from './lib/interest';
import { Hero } from './sections/Hero';
import { Interest } from './sections/Interest';
import { Loop } from './sections/Loop';
import { Pillars } from './sections/Pillars';
import { Proof } from './sections/Proof';

export function App() {
  return (
    <div className="min-h-dvh overflow-x-clip bg-ink">
      <a
        href="#reach"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-30 focus:rounded-base focus:bg-brand-a focus:px-4 focus:py-2 focus:text-[0.9rem] focus:text-white"
      >
        Skip to the four parts
      </a>

      <SiteHeader />

      <main>
        <Hero />
        <Pillars />
        <Loop />
        <Proof />
        <Interest />
      </main>

      <SiteFooter contactEmail={CONTACT_EMAIL} />
    </div>
  );
}
